module.exports = __webpack_public_path__ + "img/10.e6aa0687.jpg";